module.exports = __webpack_public_path__ + "img/simplebks-paystack-integration.5cb4e72d.gif";